export default __webpack_public_path__ + "static/media/medical_extras_img.0de0e259.png";